import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function InstituteForm() {
  const [open, setOpen] = React.useState(false);

  const Navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
    Navigate("/admin-page/student");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [formData, setFormData] = useState({
    institutename: "",
    department: "",
    faculty: "",
    course: "",
    courseduration: "",
    currentyear: "",
    regnumber: "",
    cgpa: "",
  });

  const handleInputChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check for empty fields
    const isEmptyField = Object.values(formData).some((value) => value === "");

    if (isEmptyField) {
      alert("Please fill out all fields");
    } else {
      // Submit the form (you can implement your submission logic here)

      console.log("data");

      //  console.log("Form submitted:", );
      setFormData({
        Institutename: "",
        department: "",
        faculty: "",
        course: "",
        courseduration: "",
        currentyear: "",
        regnumber: "",
        cgpa: "",
      });
    }
  };
  return (
    <div className="h-fit">
      <form onSubmit={handleSubmit}>
        <TextField
          label="Institute Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.institutename}
          onChange={handleInputChange("institutename")}
        />
        <TextField
          label="Department"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.department}
          onChange={handleInputChange("department")}
        />
        <TextField
          label="Faculty"
          type="tel"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.faculty}
          onChange={handleInputChange("faculty")}
        />
        <TextField
          label="Course"
          type="tel"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.course}
          onChange={handleInputChange("course")}
        />
        <TextField
          label="Course Duration"
          type="tel"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.courseduration}
          onChange={handleInputChange("courseduration")}
        />
        <TextField
          label="Current Year"
          type="tel"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.currentyear}
          onChange={handleInputChange("currentyear")}
        />
        <TextField
          label="Reg / Matric Number"
          type="tel"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.regnumber}
          onChange={handleInputChange("regnumber")}
        />
        <TextField
          label="CGPA"
          type="tel"
          variant="outlined"
          fullWidth
          margin="normal"
          value={formData.cgpa}
          onChange={handleInputChange("cgpa")}
        />

        <Button type="submit" variant="contained" color="primary">
          Add
        </Button>
      </form>
    </div>
  );
}

export default InstituteForm;
